<ng-container *ngIf="tripMessage$ | async as message">
  <fin-section-review-item class="mr-small-t" [icon]="message.localSettings?.iconName" [category]="iconCategory">
    <div>
      <h4 class="mr-xxsmall-b">{{ message.teaserTitle }}</h4>
    </div>
    <div [innerHTML]="message.teaserText | finSafe: 'html'"></div>
    <button *ngIf="linkText" class="ms-xsmall-r link flex--self-start medium-type underline" (click)="openModal()">
      {{ linkText }}
    </button>
  </fin-section-review-item>
</ng-container>

<fin-sustainablity-info-modal [modalOpen]="modalOpen" (closeModal)="closeModal()"></fin-sustainablity-info-modal>
